"use client";

import { dataLayer } from "@repo/analytics/data-layer-utils"; // adjust if your path is different
import {
  componentNameConstants,
  dlElementConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";

/**
 * Logs Subscription CTA click DL event.
 * @param sectionTitle - Title of the subscription section
 * @param cardTitle - Title of the card/plan
 * @param cardPrice - Price of the plan
 * @param ctaText - Button text
 * @param href - Redirect URL
 * @param index - Position index of the card
 */
export const handleSubscriptionCTADL = (
  loginStatus: string,
  sectionTitle: string,
  cardTitle: string,
  cardPrice: string,
  ctaText: string,
  href: string,
) => {
  const data = {
    section_title: sectionTitle,
    component: componentNameConstants.SUBSCRIPTION_CARD_CAROUSEL,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.LINK_CLICK,
    element: dlElementConstants.SUBSCRIPTION_CARD_CAROUSEL_CTA,
    destination_url: href,
    cta_text: ctaText,
    sub_section: `${cardTitle} - ${cardPrice}`,
  };

  const cleverTapObj = {
    EVENT_NAME: dlElementConstants.SUBSCRIPTION_CARD_CAROUSEL_CTA,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};
